module.exports = __webpack_public_path__ + "img/metals.da33b19d.svg";